module.exports = __webpack_public_path__ + "static/img/banner-about-04.a6d8cff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-about-04.jpg
// module id = ISEu
// module chunks = 98